import {observer} from 'mobx-react';
import EditAddressInfoModal from './EditAddressInfoModal';
import {t} from 'shared/core';
import InfoPanel from './InfoPanel';

const ATTRIBUTES = [
  {
    label: 'employees.profile.personal.Address Line 1',
    render: ({employee}) => employee.homeAddress1
  },
  {
    label: 'employees.profile.personal.Address Line 2',
    render: ({employee}) => employee.homeAddress2
  },
  {
    label: 'employees.profile.personal.Country',
    render: ({uiState}) => uiState.countryView
  },
  {
    label: 'employees.profile.personal.State/Province',
    render: ({uiState}) => uiState.regionView
  },
  {
    label: 'employees.profile.personal.City',
    render: ({employee}) => employee.city
  },
  {
    label: 'employees.profile.personal.Postal Code',
    render: ({employee}) => employee.postalCode
  },
];

const AddressInformation = observer(({uiState}) => {
  const {employee} = uiState;

  return (
    <>
      <InfoPanel
        uiState={uiState}
        employee={employee}
        canEdit={uiState.editDataPermission('::PERSONAL_INFORMATION')}
        onEdit={() => uiState.openAddressInfoModal()}
        title={t('employees.profile.personal.Address')}
        attributes={ATTRIBUTES}
      />
      <EditAddressInfoModal uiState={uiState} />
    </>
  );
});

export default AddressInformation;
